<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardBody>
          <h3>
            {{ $t('button.edit') }} {{ $t('fields.profile') }}
          </h3>
          <div class="row">
            <div class="col-6">
                <CInput readonly :label="$t('fields.employee')" type="text" v-model="user.employee"></CInput>
            </div>
            <div class="col-6">
              <CInput 
                readonly
                :label="$t('fields.username')" 
                type="text" 
                placeholder="Ex: jperez" 
                v-model="user.username"
                >
              </CInput>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <CInput readonly :label="$t('fields.email')" type="email" :placeholder="$t('fields.email_placeholder')" v-model="user.email"></CInput>
            </div>
            <div class="col-4">
              <CInput readonly :label="$tc('roles.label', 1)" type="text" v-model="user.role"></CInput>
            </div>
            <div class="col-4">
              <CSelect
                disabled
              :label="$t('fields.is_active')"
              :value.sync="user.status"
              :plain="true"
              :options="statuses"
              :placeholder="$t('fields.status_placeholder')"
              >
              </CSelect>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <CInput :label="$t('fields.password')" type="password" placeholder="" v-model="user.password"></CInput>
            </div>
            <div class="col-6">
              <CInput :label="$t('fields.password_confirmation')" type="password" placeholder="" v-model="user.password_confirmation"></CInput>
            </div>
          </div>
          <CButton color="success" @click="saveData()">
            <template v-if="isEditing"><CIcon :content="$options.updateIcon" /> {{ $t('button.update') }}</template>
            <template v-else><CIcon :content="$options.addIcon" /> {{ $t('button.create') }}</template>
            </CButton>
          <CButton color="primary" @click="goBack()"><CIcon :content="$options.backIcon" /> {{ $t('button.back') }}</CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import formMixin from "../../mixins/form";
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilSync, cilPlus, cilArrowLeft } from '@coreui/icons';

export default {
  name: 'Profile',
  mixins: [formMixin, localeMixin],
  addIcon: cilPlus,
  updateIcon: cilSync,
  backIcon: cilArrowLeft,
  data() {
    return {
        user: {
          employee: '',
          role: '',
          username: '',
          email: '',
          password: '',
          password_confirmation: '',
          status: ''
        },
        username_response: '',
        isAvailable: 0,
        roles: [],
        employees: [],
        statuses: [
          {
            label: i18n.t('fields.active'),
            value: "1"
          },
          {
            label: i18n.t('fields.inactive'),
            value: "0"
          }
        ],
        message: ''
    }
  },
  computed: {
      isDisabled() {
          if (!this.isEditing) {
              return this.isAvailable ? true : false;
          }
      },
      userId() {
          return this.$route.params.id;
      }
  },
  mounted() {
    this.getUser();
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'Dashboard' });
    },
    showAlert(type, msg) {
      let title = '';
      let body = '';
      let status = '';
      let redirect = true;

      switch(type) {
        case 'add':
          title = i18n.t('users.modal.created_label');
          body = i18n.t('users.modal.created_body');
          status = 'success';
          break;
        case 'edit':
          title = i18n.t('users.modal.updated_label');
          body = i18n.t('users.modal.updated_body');
          status = 'success';
          break;
        case 'error':
          title = 'Error';
          body = msg;
          status = 'danger';
          redirect = false;
          break;
      }

      this.$swal(
        title,
        body,
        status
      ).then(result => {
        if (redirect) {
          this.goBack();
        }
      });
    },
    saveData() {
        // const data = formData || this.prepareObjectData();
        const token = this.token === null ? localStorage.getItem("api_token") : this.token;
        const data = this.user;
        this.$emit("saved", data);
        let url = `/api/users/${this.userId}/profile?token=${token}`;
        let sendRequest = null;

        // url = url + "/" + this.userId + '?token=' + localStorage.getItem("api_token");
        sendRequest = async() => {
            try {
                const response = await axios.put(url, data);
                if (response.data.status === "success") {
                    this.showAlert('edit');
                }
            } catch (error) {
                if(error.response.data.message == 'The given data was invalid.'){
                    this.message = '';
                    for (let key in error.response.data.errors) {
                        if (error.response.data.errors.hasOwnProperty(key)) {
                            this.message += error.response.data.errors[key][0] + '<br>';
                        }
                    }
                    this.showAlert('error', this.message);
                } else{
                    console.log(error);
                    this.$router.push({ path: '/login' }); 
                }
            }
        };
        sendRequest();
        return data;
    },
    getUser() {
        // const id = this.$route.params.id;
        const token = this.token === null ? localStorage.getItem("api_token") : this.token;
        axios.get('/api/users/'+ this.userId + '/profile?token=' + token)
        .then(response => {
            this.user = response.data;
            this.user.status_class = this.user.status ? "primary" : "secondary";
        }).catch(error => {
            console.log(error);
            this.$router.push({ path: '/login' });
        });
    }
  }
}

</script>

<style lang="scss" scoped>
.available {
    color: green;
}
.notavailable {
    color: red;
}
</style>